<template>
    <v-dialog
        :value="value"
        @input="$emit('input', $event)"
        persistent
        scrollable
        width="90%"
        max-width="1440"
    >
        <v-card>
            <v-toolbar dense dark color="primary" flat>
                <v-icon class="mr-2">mdi-skip-next-circle-outline</v-icon>
                <v-toolbar-title>
                    Skip CE Close Case
                    <v-chip color="amber" small class="ml-2 font-weight-bold">
                        {{ detailcase.case_id }}
                    </v-chip>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text class="pt-6 px-6 px-sm-8 grey lighten-5">
                <v-row justify="center" class="mb-6">
                    <v-chip
                        :color="chk_save_img ? 'green accent-2' : 'grey lighten-2'"
                        class="mr-2 px-4"
                        label
                    >
                        <v-icon left small v-if="chk_save_img"
                            >mdi-check-circle</v-icon
                        >
                        <b>Step 1 : Upload Images</b>
                    </v-chip>
                    <v-chip
                        :color="step === 2 ? 'blue lighten-4' : 'grey lighten-2'"
                        class="px-4"
                        label
                    >
                        <b>Step 2 : Close Case Data</b>
                    </v-chip>
                </v-row>

                <v-form ref="form" v-model="valid">
                    <div v-if="step === 1">
                        <v-card outlined rounded="lg" class="pa-5 mb-4">
                            <div class="section-title mb-4">
                                <v-icon color="primary" class="mr-2"
                                    >mdi-image-multiple-outline</v-icon
                                >
                                Upload Images
                            </div>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <div class="upload-label mb-2">
                                        CSO Image
                                    </div>
                                    <vue-upload-multiple-image
                                        @upload-success="uploadCso"
                                        @before-remove="beforeRemoveCso"
                                        @edit-image="() => {}"
                                        dragText="UPLOAD"
                                        browseText="CSO"
                                        primaryText="cso image"
                                        markIsPrimaryText="จัดลำดับรูปภาพ"
                                        idUpload="skipce_upload_cso"
                                        editUpload="skipce_edit_cso"
                                        :maxImage="50"
                                    ></vue-upload-multiple-image>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="upload-label mb-2">
                                        Attach Image
                                    </div>
                                    <vue-upload-multiple-image
                                        @upload-success="uploadAttach"
                                        @before-remove="beforeRemoveAttach"
                                        @edit-image="() => {}"
                                        dragText="UPLOAD"
                                        browseText="ATTACH"
                                        primaryText="attach image"
                                        markIsPrimaryText="จัดลำดับรูปภาพ"
                                        idUpload="skipce_upload_attach"
                                        editUpload="skipce_edit_attach"
                                        :maxImage="50"
                                    ></vue-upload-multiple-image>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-row align="center">
                            <v-col class="text-right">
                                <!-- ปิดการใช้งาน Skip Upload ไว้ก่อน -->
                                <!--
                                <v-btn text @click="skipUpload">
                                    Skip Upload
                                </v-btn>
                                -->
                                <v-progress-linear
                                    v-if="saving_img"
                                    indeterminate
                                    color="cyan"
                                    class="d-inline-block mx-4"
                                    style="max-width: 160px; vertical-align: middle;"
                                ></v-progress-linear>
                                <v-btn
                                    color="success"
                                    large
                                    @click="saveImages"
                                    :disabled="saving_img"
                                >
                                    <v-icon small class="mr-1"
                                        >mdi-content-save</v-icon
                                    >Save Images
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>

                    <div v-else>
                        <v-card outlined rounded="lg" class="pa-5 mb-4">
                            <div class="section-title mb-4">
                                <v-icon color="primary" class="mr-2"
                                    >mdi-clipboard-text-outline</v-icon
                                >
                                Job Information
                            </div>
                            <v-row>
                                <v-col cols="12" sm="8" md="6">
                                    <v-select
                                        label="Job Status"
                                        :items="en_item"
                                        item-text="text"
                                        item-value="id"
                                        v-model="form.engineer_status"
                                        :rules="requiredRule"
                                        dense
                                        outlined
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-menu
                                        v-model="onsiteAtMenu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                label="Onsite at"
                                                v-model="form.onsite_at"
                                                readonly
                                                dense
                                                outlined
                                                :rules="requiredRule"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="form.onsite_at"
                                            no-title
                                            @input="onsiteAtMenu = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>

                            <template
                                v-if="detailcase.parts && detailcase.parts.length"
                            >
                                <v-divider class="mb-4"></v-divider>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        v-for="(row_part, idx) in detailcase.parts"
                                        :key="idx"
                                    >
                                        <v-chip dense class="mb-2" label>
                                            <strong>{{
                                                row_part.part_name
                                            }}</strong>
                                            <span
                                                class="ml-2 font-weight-light text-lowercase"
                                            >
                                                {{ row_part.part_description }}
                                            </span>
                                        </v-chip>
                                        <v-select
                                            dense
                                            outlined
                                            :items="
                                                row_part.status != 'Back Order'
                                                    ? part_item
                                                    : part_backorder_item
                                            "
                                            item-text="text"
                                            item-value="id"
                                            label="Status Part"
                                            v-model="
                                                form.part[
                                                    'P' + row_part.part_issue_id
                                                ]
                                            "
                                            :rules="requiredRule"
                                        ></v-select>

                                        <v-row
                                            v-if="
                                                form.part[
                                                    'P' + row_part.part_issue_id
                                                ] === 'Bad' ||
                                                    form.part[
                                                        'P' +
                                                            row_part.part_issue_id
                                                    ] === 'DOA'
                                            "
                                        >
                                            <v-col cols="6">
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    label="CT เก่า"
                                                    v-model="
                                                        form.ct_old[
                                                            'CTO' +
                                                                row_part.part_issue_id
                                                        ]
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    label="CT ใหม่"
                                                    v-model="
                                                        form.ct_new[
                                                            'CTN' +
                                                                row_part.part_issue_id
                                                        ]
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-card>

                        <v-card
                            v-if="form.engineer_status === 'Complete'"
                            outlined
                            rounded="lg"
                            class="pa-5 mb-4"
                        >
                            <div class="section-title mb-4">
                                <v-icon color="primary" class="mr-2"
                                    >mdi-emoticon-outline</v-icon
                                >
                                Customer Satisfaction
                            </div>
                            <v-row justify="center">
                                <v-col cols="12" class="text-center">
                                    ลูกค้าพึงพอใจกับการบริการครั้งนี้หรือไม่
                                </v-col>
                                <v-col cols="12" class="text-center mar-t-10">
                                    <img
                                        class="fix-png-a"
                                        :class="
                                            form.customer_level === 'L'
                                                ? 'red'
                                                : ''
                                        "
                                        src="../../../assets/all/sad.png"
                                        @click="clickCustomerLevel('L')"
                                    />
                                    <img
                                        class="fix-png-a ml-2 mr-2"
                                        :class="
                                            form.customer_level === 'M'
                                                ? 'yellow'
                                                : ''
                                        "
                                        src="../../../assets/all/face.png"
                                        @click="clickCustomerLevel('M')"
                                    />
                                    <img
                                        class="fix-png-a"
                                        :class="
                                            form.customer_level === 'H'
                                                ? 'teal accent-3'
                                                : ''
                                        "
                                        src="../../../assets/all/smile.png"
                                        @click="clickCustomerLevel('H')"
                                    />
                                </v-col>
                                <v-col
                                    v-if="chk_customer_level"
                                    cols="12"
                                    class="text-center"
                                >
                                    <span class="text-color-red font-fix-13"
                                        >** Customer level is required</span
                                    >
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card outlined rounded="lg" class="pa-5 mb-4">
                            <div class="section-title mb-5">
                                <v-icon color="primary" class="mr-2"
                                    >mdi-clock-time-four-outline</v-icon
                                >
                                Time &amp; Reference
                            </div>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <div class="field-label mb-2">
                                        Time Start
                                    </div>
                                    <vue-timepicker
                                        v-model="form.start"
                                        class="time-picker-full"
                                    ></vue-timepicker>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <div class="field-label mb-2">
                                        Time Stop
                                    </div>
                                    <vue-timepicker
                                        v-model="form.stop"
                                        class="time-picker-full"
                                    ></vue-timepicker>
                                </v-col>
                            </v-row>
                            <v-row class="mt-2">
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        outlined
                                        dense
                                        label="Csono"
                                        v-model="form.csono"
                                        :rules="requiredRule"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        outlined
                                        dense
                                        label="Email"
                                        background-color="#FFFF"
                                        v-model="form.email"
                                    ></v-text-field>
                                    <v-chip
                                        v-if="detailcase.customer_email"
                                        color="amber"
                                        x-small
                                        class="mt-n1"
                                    >
                                        Cus. Email :
                                        {{ detailcase.customer_email }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card outlined rounded="lg" class="pa-5">
                            <div class="section-title mb-4">
                                <v-icon color="primary" class="mr-2"
                                    >mdi-text-box-edit-outline</v-icon
                                >
                                Solution
                            </div>
                            <v-textarea
                                outlined
                                label="Solution"
                                v-model="form.solution"
                                :rules="requiredRule"
                                rows="4"
                            ></v-textarea>
                        </v-card>

                        <v-row align="center" class="mt-2">
                            <v-col class="text-right">
                                <v-btn text @click="step = 1">
                                    <v-icon small class="mr-1"
                                        >mdi-arrow-left-bold-circle-outline</v-icon
                                    >Back
                                </v-btn>
                                <v-progress-linear
                                    v-if="saving"
                                    indeterminate
                                    color="cyan"
                                    class="d-inline-block mx-4"
                                    style="max-width: 160px; vertical-align: middle;"
                                ></v-progress-linear>
                                <v-btn
                                    color="success"
                                    large
                                    :disabled="!valid || saving"
                                    @click="confirmSave"
                                >
                                    <v-icon small class="mr-1"
                                        >mdi-content-save</v-icon
                                    >Save &amp; Close Case
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios"
import resizebase64 from "resize-base64"
import VueUploadMultipleImage from "vue-upload-multiple-image"
import VueTimepicker from "vue2-timepicker/src"
import "vue2-timepicker/dist/VueTimepicker.css"

export default {
    components: {
        VueUploadMultipleImage,
        VueTimepicker,
    },
    props: {
        value: Boolean,
        detailcase: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            step: 1,
            valid: false,
            saving_img: false,
            saving: false,
            chk_save_img: false,
            chk_save_img_skip: false,
            chk_customer_level: false,
            onsiteAtMenu: false,
            cso: [],
            attach: [],
            form: {
                engineer_status: "",
                customer_level: "",
                part: {},
                ct_old: {},
                ct_new: {},
                overa: {},
                overb: {},
                singlepart: {},
                start: "",
                stop: "",
                onsite_at: "",
                csono: "",
                email: "",
                solution: "",
            },
            requiredRule: [(v) => !!v || "This field is required"],
            en_item: [
                {
                    id: "Complete",
                    text: "ซ่อมเสร็จ : เครื่องลูกค้าใช้งานได้แล้ว",
                },
                {
                    id: "Incomplete",
                    text:
                        "ซ่อมไม่จบ : Verify / เสนอราคา / รอ Part / เบิก Part ใหม่",
                },
                {
                    id: "Waiting",
                    text: "ลูกค้าขอทดสอบเครื่องก่อน",
                },
                {
                    id: "PUR",
                    text: "ยกเครื่องลูกค้ามาซ่อม / NONHP วาง Spare",
                },
                {
                    id: "PUR_M",
                    text: "HP จอ Same Item",
                },
                {
                    id: "Pickup return",
                    text: "ส่งเครื่องคืนลูกค้า",
                },
                {
                    id: "DOA",
                    text: "ทำเรื่อง DOA เครื่อง",
                },
            ],
            part_item: [
                {
                    id: "Bad",
                    text:
                        "ใช้ Part 73 - Used & Consumed (SAUS-Used + Consumed)",
                },
                {
                    id: "Good",
                    text: "ไม่ใช้ Part 72 - Returned good (SAUN-Unused)",
                },
                {
                    id: "DOA",
                    text: "Part ทำคืน 55 - DOA - (SAUS-Used + Not Consumed)",
                },
                {
                    id: "Same Item",
                    text: "วาง Spare / Same Item",
                },
                {
                    id: "Pending",
                    text: "ยังไม่คืน Part ถือไว้ใช้ในซับต่อไป",
                },
                {
                    id: "Install",
                    text: "ติดตั้งถาวร",
                },
            ],
            part_backorder_item: [
                {
                    id: "Cancel",
                    text: "ไม่ใช้ Part",
                },
                {
                    id: "Pending",
                    text: "ต้องใช้ Part / รอ Part",
                },
            ],
        }
    },
    computed: {
        tk() {
            return {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
        },
    },
    watch: {
        value(val) {
            if (val) {
                this.setDefaultTimes()
                this.form.csono = "ODM"
                this.form.onsite_at = new Date().toISOString().substr(0, 10)
                this.initPartsForm()
            }
        },
    },
    methods: {
        // ตั้งค่า index เริ่มต้นให้ทุก part ล่วงหน้า (เหมือน Onsite change_case())
        // ไม่งั้นถ้า part ไหนไม่ถูกแตะเลย key นั้นจะไม่ถูกสร้างใน object
        // ทำให้ backend เจอ "Undefined index" ตอนอ่าน ct_old/ct_new/part
        initPartsForm() {
            if (!this.detailcase.parts) return
            this.detailcase.parts.forEach((each) => {
                this.$set(this.form.part, "P" + each.part_issue_id, "")
                this.$set(this.form.ct_old, "CTO" + each.part_issue_id, "")
                this.$set(this.form.ct_new, "CTN" + each.part_issue_id, "")
                this.$set(this.form.overa, "overa" + each.part_issue_id, "No")
                this.$set(this.form.overb, "overb" + each.part_issue_id, "")
                this.$set(
                    this.form.singlepart,
                    "PART" + each.part_issue_id,
                    ""
                )
            })
        },
        // ตั้งค่า default Time Start/Stop = เวลาปัจจุบัน (Stop = ตอนนี้, Start = ตอนนี้ - 15 นาที)
        // ตามพฤติกรรมเดิมของหน้า Onsite ตอนกด Close Case
        setDefaultTimes() {
            const now = new Date()
            let HH = now.getHours()
            let mStop = now.getMinutes()
            let mStart

            HH = HH <= 9 ? "0" + HH : HH.toString()
            if (mStop <= 15) {
                mStart = "00"
                mStop = mStop <= 9 ? "0" + mStop : mStop.toString()
            } else {
                mStart = mStop - 15
                mStart = mStart <= 9 ? "0" + mStart : mStart.toString()
                mStop = mStop.toString()
            }

            this.form.start = { HH, mm: mStart }
            this.form.stop = { HH, mm: mStop }
        },
        uploadCso(formData, index, fileList) {
            this.cso = fileList
        },
        uploadAttach(formData, index, fileList) {
            this.attach = fileList
        },
        beforeRemoveCso(index, done) {
            if (confirm("remove image")) done()
        },
        beforeRemoveAttach(index, done) {
            if (confirm("remove image")) done()
        },
        // ปิดการใช้งาน Skip Upload ไว้ก่อน (ดูปุ่มที่ comment ไว้ใน template)
        // skipUpload() {
        //     this.chk_save_img_skip = true
        //     this.chk_save_img = true
        //     this.step = 2
        // },
        async saveImages() {
            this.saving_img = true
            const formData = new FormData()
            formData.append("maincase_id", this.detailcase.maincase_id)
            formData.append("subcase", this.detailcase.subcase)
            this.cso.forEach((img, i) => {
                formData.append(`cso[${i}]`, resizebase64(img.path, 1000, 1000))
            })
            this.attach.forEach((img, i) => {
                formData.append(
                    `attach[${i}]`,
                    resizebase64(img.path, 750, 750)
                )
            })
            const url = `${process.env.VUE_APP_ROOT_API}/api/engineer/upload`
            console.log(
                {
                    maincase_id: this.detailcase.maincase_id,
                    subcase: this.detailcase.subcase,
                    cso: this.cso,
                    attach: this.attach,
                },
                "-- engineer/upload request"
            )
            try {
                const response = await axios.post(url, formData, this.tk)
                console.log(response, "-- engineer/upload response")
                this.chk_save_img = true
                this.step = 2
            } catch (error) {
                console.log(error, "-- upload img error")
                this.$swal(
                    "ปิดงานไม่สำเร็จ",
                    "รบกวนติดต่อ Programmer Team !",
                    "warning"
                )
            }
            this.saving_img = false
        },
        clickCustomerLevel(c) {
            this.form.customer_level = c
        },
        async confirmSave() {
            if (
                this.form.engineer_status === "Complete" &&
                !this.form.customer_level
            ) {
                this.chk_customer_level = true
                return
            }
            this.chk_customer_level = false
            this.saving = true
            const formData = new FormData()
            formData.append("maincase_id", this.detailcase.maincase_id)
            formData.append("subcase", this.detailcase.subcase)
            formData.append("engineer_status", this.form.engineer_status)
            formData.append("customer_level", this.form.customer_level)
            formData.append("part", JSON.stringify(this.form.part))
            formData.append("ct_old", JSON.stringify(this.form.ct_old))
            formData.append("ct_new", JSON.stringify(this.form.ct_new))
            formData.append("overa", JSON.stringify(this.form.overa))
            formData.append("overb", JSON.stringify(this.form.overb))
            formData.append(
                "singlepart",
                JSON.stringify(this.form.singlepart)
            )
            const timeStart = this.form.start
                ? `${this.form.start.HH}:${this.form.start.mm}`
                : ""
            const timeStop = this.form.stop
                ? `${this.form.stop.HH}:${this.form.stop.mm}`
                : ""
            formData.append("start", timeStart)
            formData.append("stop", timeStop)
            formData.append("csono", this.form.csono)
            formData.append("email", this.form.email)
            formData.append("solution", this.form.solution)
            formData.append("project_name", this.detailcase.project_name)
            formData.append("lat_start", "")
            formData.append("lng_start", "")
            formData.append("lat", "")
            formData.append("lng", "")
            formData.append("address", "")
            formData.append("travel_time", "")
            formData.append("km", "")
            formData.append("quotation", "")
            formData.append("fid", "")
            formData.append("fid_text", "")
            formData.append("printcount", "")
            formData.append("sn_old", "")
            formData.append("sn_new", "")
            formData.append("sameitem_no", "")
            formData.append("ce_symptom", "")
            formData.append(
                "skip_upload",
                this.chk_save_img_skip ? "Y" : "N"
            )
            formData.append("onsite_at", this.form.onsite_at)
            // gps_at = onsite_at + time stop ต่อกันเป็น datetime "YYYY-MM-DD HH:mm:ss"
            formData.append(
                "gps_at",
                `${this.form.onsite_at} ${timeStop}:00`
            )
            formData.append("closed_type", "admin odm close")
            const url = `${process.env.VUE_APP_ROOT_API}/api/engineer/closecase`
            console.log(
                Object.fromEntries(formData.entries()),
                "-- engineer/closecase request"
            )
            try {
                const response = await axios.post(url, formData, this.tk)
                console.log(response, "-- engineer/closecase response")
                this.$emit("saved")
                this.closeDialog()
            } catch (error) {
                console.log(error, "-- error close case")
                this.$swal(
                    "ปิดงานไม่สำเร็จ",
                    "รบกวนติดต่อ Programmer Team !",
                    "warning"
                )
            }
            this.saving = false
        },
        resetForm() {
            this.step = 1
            this.valid = false
            this.saving_img = false
            this.saving = false
            this.chk_save_img = false
            this.chk_save_img_skip = false
            this.chk_customer_level = false
            this.cso = []
            this.attach = []
            this.form = {
                engineer_status: "",
                customer_level: "",
                part: {},
                ct_old: {},
                ct_new: {},
                overa: {},
                overb: {},
                singlepart: {},
                start: "",
                stop: "",
                onsite_at: "",
                csono: "",
                email: "",
                solution: "",
            }
        },
        closeDialog() {
            this.resetForm()
            this.$emit("input", false)
        },
    },
}
</script>

<style scoped>
.upload-label {
    font-weight: 500;
}
.field-label {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    font-size: 13px;
}
.section-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #37474f;
}
.fix-png-a {
    width: 42px;
    height: 42px;
    cursor: pointer;
    border-radius: 50%;
    padding: 4px;
    transition: transform 0.15s ease;
}
.fix-png-a:hover {
    transform: scale(1.1);
}
.time-picker-full >>> input.display-time {
    width: 100%;
    height: 40px;
    border: 1px solid rgba(0, 0, 0, 0.38);
    border-radius: 4px;
    padding-left: 12px;
}
</style>
